import React from "react";
import {
    Grid, TextField, Checkbox, FormControlLabel, Typography, InputAdornment,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import EditIcon from "@mui/icons-material/Edit";
import MultiEmailInput from "../common/MultiEmailInput";
import { fieldSx } from "./bottleOrderFormHelpers";

const ContactAddressStep = ({ formData, handleChange, handleCheckboxChange, loading, setClientDialogOpen }) => (
    <>
        {/* Row 1 — account + shipping details */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
                <TextField
                    fullWidth size="small" variant="outlined" label="Account Number"
                    value={
                        formData.accountNumber
                            ? `${formData.accountNumber?.trim() ?? ""}${formData.shippingName?.trim() ? ` — ${formData.shippingName.trim()}` : ""}`
                            : "Click to select client"
                    }
                    onClick={() => !loading && setClientDialogOpen(true)}
                    sx={fieldSx}
                    helperText={loading ? "Updating account..." : "Click to change client/account"}
                    InputProps={{
                        readOnly: true,
                        style: { cursor: loading ? "not-allowed" : "pointer" },
                        startAdornment: !formData.accountNumber ? (
                            <InputAdornment position="start"><BusinessIcon color="primary" fontSize="small" /></InputAdornment>
                        ) : null,
                        endAdornment: (
                            <InputAdornment position="end"><EditIcon color="primary" sx={{ fontSize: 16 }} /></InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField fullWidth size="small" variant="outlined" label="Shipping Name"
                    value={formData.shippingName} onChange={handleChange("shippingName")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField fullWidth size="small" variant="outlined" label="Contact"
                    value={formData.shippingContact} onChange={handleChange("shippingContact")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField fullWidth size="small" variant="outlined" label="Phone"
                    value={formData.shippingPhone} onChange={handleChange("shippingPhone")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField fullWidth size="small" variant="outlined" label="Fax"
                    value={formData.shippingFax} onChange={handleChange("shippingFax")} sx={fieldSx} />
            </Grid>
        </Grid>

        {/* Row 2 — address */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
                <TextField fullWidth size="small" variant="outlined" label="Address Line 1"
                    value={formData.shippingAddress} onChange={handleChange("shippingAddress")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <TextField fullWidth size="small" variant="outlined" label="Address Line 2"
                    value={formData.shippingAddress2} onChange={handleChange("shippingAddress2")} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField fullWidth size="small" variant="outlined" label="City"
                    value={formData.shippingCity} onChange={handleChange("shippingCity")} sx={fieldSx} />
            </Grid>
            <Grid item xs={6} sm={3} md={1}>
                <TextField fullWidth size="small" variant="outlined" label="State"
                    value={formData.shippingState} onChange={handleChange("shippingState")} sx={fieldSx} />
            </Grid>
            <Grid item xs={6} sm={3} md={1}>
                <TextField fullWidth size="small" variant="outlined" label="Zip"
                    value={formData.shippingZip} onChange={handleChange("shippingZip")} sx={fieldSx} />
            </Grid>
        </Grid>

        {/* Row 3 — email + checkboxes */}
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
                <MultiEmailInput value={formData.shippingEmail} onChange={handleChange("shippingEmail")} label="Shipping Email" />
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
                <FormControlLabel
                    control={<Checkbox checked={formData.useMaintenance} onChange={handleCheckboxChange("useMaintenance")} color="primary" size="small" />}
                    label={<Typography sx={{ fontSize: "0.875rem" }}>Use Maintenance Info</Typography>}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
                {/* From clients.RoutineShipment; edited in client maintenance, same as VLP */}
                <TextField fullWidth size="small" variant="outlined" label="Routine Shipment"
                    value={formData.routineShipmentNotes} multiline minRows={2} sx={fieldSx}
                    InputProps={{ readOnly: true }}
                    helperText="From client maintenance" />
            </Grid>
        </Grid>
    </>
);

export default ContactAddressStep;
